import LeafInput from "../../../../common/leaf/LeafInput/LeafInput";
import LeafSlider from "../../../../common/leaf/LeafSlider/LeafSlider";
import "./EarningsCalculatorInput.scss";

interface EarningsCalculatorInputProps {
  countryCode: string;
  min: number;
  max: number;
  base: number;
  value: number | "";
  marks: { Label: string; Value: number }[];
  suffix?: string;
  placeholder?: string;
  isLoading?: boolean;
  onChange?: (value: number | "") => void;
  disabled?: boolean;
  ariaLabel?: string;
}

const EarningsCalculatorInput = ({
  countryCode,
  min,
  max,
  base,
  value,
  marks,
  suffix,
  placeholder,
  isLoading = false,
  onChange,
  disabled,
  ariaLabel,
}: EarningsCalculatorInputProps) => {
  const handleValueChange = (newValue: number | "") => {
    onChange?.(newValue);
  };

  return (
    <div className="earnings-calculator__input__container">
      <LeafInput
        isLoading={isLoading}
        countryCode={countryCode}
        value={value}
        placeholder={placeholder}
        onChange={handleValueChange}
        suffix={suffix}
        min={base}
        max={max}
        disabled={disabled}
      />
      <LeafSlider
        isLoading={isLoading}
        base={base}
        value={Number(value)}
        min={min}
        max={max}
        marks={marks}
        onChange={handleValueChange}
        tooltipSuffixText={suffix}
        disabled={disabled}
        ariaLabel={ariaLabel}
      />
    </div>
  );
};

export default EarningsCalculatorInput;
